import { render, staticRenderFns } from "./StaffingPositionFeeInput.vue?vue&type=template&id=156e9363&"
import script from "./StaffingPositionFeeInput.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StaffingPositionFeeInput.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports